import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CurrencyFormatOptions } from '../interfaces/currency-format-options';
import { HttpClient } from '@angular/common/http';
import { Currency } from '../interfaces/currency';
import { environment } from '@environments/environment';

interface CurrencyServiceData {
    options: CurrencyFormatOptions;
}

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    private data: CurrencyServiceData = {
        options: {}
    };

    private changesSubject$: Subject<CurrencyFormatOptions> = new Subject();

    changes$: Observable<CurrencyFormatOptions> = this.changesSubject$.asObservable();

    get options(): CurrencyFormatOptions {
        return this.data.options;
    }
    set options(value: CurrencyFormatOptions) {
        localStorage.setItem('currency', value.code);
        this.data.options = value;
        this.changesSubject$.next(value);
    }

    constructor(private httpClient: HttpClient) {
        // load profile
        const currency = localStorage.getItem('currency');
        this.data.options = {
            code: 'USD',
            display: 'symbol',
            digitsInfo: '1.2-2',
            locale: 'en-US'
        };

        if (currency) {
            this.data.options = {
                code: currency,
                digitsInfo: '1.0-0'
            };
        }
    }

    // get filter by category id
    public GetAll(): Observable<any> {
        return this.httpClient.get<any>(`${environment.apiUrl}/api/currency/getall`);
    }

}
